import axios from "axios";
import types from "./types";
import {createError, logError, logSuccess} from "./message";

//GetRequests
function listOrganizationsGetRequest(regionId) {
  return axios(`/work/api/dict/5?arg=${regionId}`, {
    headers: {'Accept': 'application/json'},
  });
}

function listRegionsGetRequest() {
  return axios(`/work/api/dict/7`, {
    headers: {'Accept': 'application/json'},
  });
}

function listMunicipalsGetRequest(regionId) {
  let url = (regionId !== null && regionId !== 'undefined' && regionId > 0)
    ? `/work/api/dict/8?arg=${regionId}`
    : `/work/api/dict/8`;
  return axios(url, {
    headers: {'Accept': 'application/json'},
  });
}

function listWsCategoriesGetRequest() {
  return axios(`/work/api/dict/9`, {
    headers: {'Accept': 'application/json'},
  });
}

function listTargetGroupGetRequest() {
  return axios(`/work/api/dict/10`, {
    headers: {'Accept': 'application/json'},
  });
}

function listTrialFormGetRequest() {
  return axios(`/work/api/dict/11`, {
    headers: {'Accept': 'application/json'},
  });
}

function listEduFormGetRequest() {
  return axios(`/work/api/dict/12`, {
    headers: {'Accept': 'application/json'},
  });
}

function listLegalFormGetRequest() {
  return axios(`/work/api/dict/16`, {
    headers: {'Accept': 'application/json'},
  });
}

function listGroupTypeGetRequest() {
  return axios(`/work/api/dict/17`, {
    headers: {'Accept': 'application/json'},
  });
}

function listPersonPostGetRequest() {
  return axios(`/work/api/dict/18`, {
    headers: {'Accept': 'application/json'},
  });
}

function listSkillGetRequest(categoryId) {
  let url = (categoryId !== null && categoryId !== 'undefined' && categoryId > 0)
    ? `/work/api/dict/13?arg=${categoryId}`
    : '/work/api/dict/19';
  return axios(url, {
    headers: {'Accept': 'application/json'},
  });
}

function listModuleGetRequest() {
  return axios(`/work/api/dict/14`, {
    headers: {'Accept': 'application/json'},
  });
}

function listOrganizationsRequest() {
  return {
    type: types.DICT_ALL_ORGANIZATION_REQUEST,
    isFetchingOrganizations: true
  };
}

function listOrganizationsReceive(orglist) {
  return {
    type: types.DICT_ALL_ORGANIZATION_COMPLETE,
    organizationList: orglist.data || [],
    isFetchingOrganizations: false
  }
}

function listOrganizationsError(orglistError) {
  return {
    type: types.DICT_ALL_ORGANIZATION_ERROR,
    isFetchingOrganizations: false,
    orglistError
  };
}

function listRegionsRequest() {
  return {
    type: types.DICT_ALL_REGION_REQUEST,
    isFetchingRegions: true
  };
}

function listRegionsReceive(regionlist) {
  return {
    type: types.DICT_ALL_REGION_COMPLETE,
    regionList: regionlist.data || [],
    isFetchingRegions: false
  }
}

function listRegionsError(regionlistError) {
  return {
    type: types.DICT_ALL_REGION_ERROR,
    isFetchingRegions: false,
    regionlistError
  };
}

function listMunicipalsRequest() {
  return {
    type: types.DICT_ALL_MUNICIPAL_REQUEST,
    isFetchingMunicipals: true
  };
}

function listMunicipalsReceive(molist) {
  return {
    type: types.DICT_ALL_MUNICIPAL_COMPLETE,
    municipalList: molist.data || [],
    isFetchingMunicipals: false
  }
}

function listMunicipalsError(molistError) {
  return {
    type: types.DICT_ALL_MUNICIPAL_ERROR,
    isFetchingMunicipals: false,
    molistError
  };
}

function listWsCategoriesRequest() {
  return {
    type: types.DICT_ALL_WS_CATEGORY_REQUEST,
    isFetchingWsCategories: true
  };
}

function listWsCategoriesReceive(categories) {
  return {
    type: types.DICT_ALL_WS_CATEGORY_COMPLETE,
    wsCategoryList: categories.data || [],
    isFetchingWsCategories: false
  }
}

function listWsCategoriesError(categoriesError) {
  return {
    type: types.DICT_ALL_WS_CATEGORY_ERROR,
    isFetchingWsCategories: false,
    categoriesError
  };
}

function listTargetGroupRequest() {
  return {
    type: types.DICT_ALL_TARGET_GROUP_REQUEST,
    isFetchingTargetGroups: true
  };
}

function listTargetGroupReceive(tgList) {
  return {
    type: types.DICT_ALL_TARGET_GROUP_COMPLETE,
    targetGroupList: tgList.data || [],
    isFetchingTargetGroups: false
  }
}

function listTargetGroupError(tgListError) {
  return {
    type: types.DICT_ALL_TARGET_GROUP_ERROR,
    isFetchingTargetGroups: false,
    tgListError
  };
}

function listTrialFormRequest() {
  return {
    type: types.DICT_ALL_TRIAL_FORM_REQUEST,
    isFetchingTrialForms: true
  };
}

function listTrialFormReceive(tfList) {
  return {
    type: types.DICT_ALL_TRIAL_FORM_COMPLETE,
    trialFormList: tfList.data || [],
    isFetchingTrialForms: false
  }
}

function listTrialFormError(tfListError) {
  return {
    type: types.DICT_ALL_TRIAL_FORM_ERROR,
    isFetchingTrialForms: false,
    tfListError
  };
}

function listEduFormRequest() {
  return {
    type: types.DICT_ALL_EDU_FORM_REQUEST,
    isFetchingEduForms: true
  };
}

function listEduFormReceive(efList) {
  return {
    type: types.DICT_ALL_EDU_FORM_COMPLETE,
    eduFormList: efList.data || [],
    isFetchingEduForms: false
  }
}

function listEduFormError(efListError) {
  return {
    type: types.DICT_ALL_EDU_FORM_ERROR,
    isFetchingEduForms: false,
    efListError
  };
}

function listLegalFormRequest() {
  return {
    type: types.DICT_ORG_LEGAL_FORM_REQUEST,
    isFetchingLegalForms: true
  };
}

function listLegalFormReceive(lfList) {
  return {
    type: types.DICT_ORG_LEGAL_FORM_COMPLETE,
    legalFormList: lfList.data || [],
    isFetchingLegalForms: false
  }
}

function listLegalFormError(lfListError) {
  return {
    type: types.DICT_ORG_LEGAL_FORM_ERROR,
    isFetchingLegalForms: false,
    lfListError
  };
}

function listGroupTypeRequest() {
  return {
    type: types.DICT_GROUP_TYPES_REQUEST,
    isFetchingGroupType: true
  };
}

function listGroupTypeReceive(gtList) {
  return {
    type: types.DICT_GROUP_TYPES_COMPLETE,
    groupTypeList: gtList.data || [],
    isFetchingGroupType: false
  }
}

function listGroupTypeError(gtListError) {
  return {
    type: types.DICT_GROUP_TYPES_ERROR,
    isFetchingGroupType: false,
    gtListError
  };
}

function listPersonPostRequest() {
  return {
    type: types.DICT_PERSON_POST_REQUEST,
    isFetchingPersonPost: true
  };
}

function listPersonPostReceive(ppList) {
  return {
    type: types.DICT_PERSON_POST_COMPLETE,
    personPostList: ppList.data || [],
    isFetchingPersonPost: false
  }
}

function listPersonPostError(personPostListError) {
  return {
    type: types.DICT_PERSON_POST_ERROR,
    isFetchingPersonPost: false,
    personPostListError
  };
}

function listSkillRequest() {
  return {
    type: types.DICT_ALL_SKILLS_REQUEST,
    isFetchingSkills: true
  };
}

function listSkillReceive(skillList) {
  return {
    type: types.DICT_ALL_SKILLS_COMPLETE,
    skillList: skillList.data || [],
    isFetchingSkills: false
  }
}

function listSkillError(skillListError) {
  return {
    type: types.DICT_ALL_SKILLS_ERROR,
    isFetchingSkills: false,
    skillListError
  };
}

function listModuleRequest() {
  return {
    type: types.DICT_ALL_MODULES_REQUEST,
    isFetchingModules: true
  };
}

function listModuleReceive(moduleList) {
  return {
    type: types.DICT_ALL_MODULES_COMPLETE,
    moduleList: moduleList.data || [],
    isFetchingModules: false
  }
}

function listModuleError(moduleListError) {
  return {
    type: types.DICT_ALL_MODULES_ERROR,
    isFetchingModules: false,
    moduleListError
  };
}

export function getDictOrganizations(regionId) {
  return (dispatch) => {
    dispatch(listOrganizationsRequest());
    return listOrganizationsGetRequest(regionId)
      .then(response => {
        if (response.status === 200) {
          dispatch(listOrganizationsReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listOrganizationsError(message));
        } else {
          logError(err);
          dispatch(listOrganizationsError(createError("Не удалось загрузить список организаций")));
        }
      });
  }
}

export function getDictRegions() {
  return (dispatch) => {
    dispatch(listRegionsRequest());
    return listRegionsGetRequest()
      .then(response => {
        if (response.status === 200) {
          dispatch(listRegionsReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listRegionsError(message));
        } else {
          logError(err);
          dispatch(listRegionsError(createError("Не удалось загрузить список регионов")));
        }
      });
  }
}

export function getDictMunicipals(regionId) {
  //console.log(regionId);
  return (dispatch) => {
    dispatch(listMunicipalsRequest());
    return listMunicipalsGetRequest(regionId)
      .then(response => {
        if (response.status === 200) {
          dispatch(listMunicipalsReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listMunicipalsError(message));
        } else {
          logError(err);
          dispatch(listMunicipalsError(createError("Не удалось загрузить список муниципальных образований")));
        }
      });
  }
}

export function getDictWsCategories() {
  return (dispatch) => {
    dispatch(listWsCategoriesRequest());
    return listWsCategoriesGetRequest()
      .then(response => {
        if (response.status === 200) {
          dispatch(listWsCategoriesReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listWsCategoriesError(message));
        } else {
          logError(err);
          dispatch(listWsCategoriesError(createError("Не удалось загрузить список категорий компетенций")));
        }
      });
  }
}

export function getSkillsByCategory(categoryId) {
  return (dispatch) => {
    dispatch(listSkillRequest());
    return listSkillGetRequest(categoryId)
      .then(response => {
        if (response.status === 200) {
          dispatch(listSkillReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listSkillError(message));
        } else {
          logError(err);
          dispatch(listSkillError(createError("Не удалось загрузить список компетенций")));
        }
      });
  }
}

export function getDictTargetGroups() {
  return (dispatch) => {
    dispatch(listTargetGroupRequest());
    return listTargetGroupGetRequest()
      .then(response => {
        if (response.status === 200) {
          dispatch(listTargetGroupReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listTargetGroupError(message));
        } else {
          logError(err);
          dispatch(listTargetGroupError(createError("Не удалось загрузить список категорий слушателей")));
        }
      });
  }
}

export function getDictTrialForms() {
  return (dispatch) => {
    dispatch(listTrialFormRequest());
    return listTrialFormGetRequest()
      .then(response => {
        if (response.status === 200) {
          dispatch(listTrialFormReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listTrialFormError(message));
        } else {
          logError(err);
          dispatch(listTrialFormError(createError("Не удалось загрузить список форм аттестации")));
        }
      });
  }
}

export function getDictEduForms() {
  return (dispatch) => {
    dispatch(listEduFormRequest());
    return listEduFormGetRequest()
      .then(response => {
        if (response.status === 200) {
          dispatch(listEduFormReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listEduFormError(message));
        } else {
          logError(err);
          dispatch(listEduFormError(createError("Не удалось загрузить список форм обучения")));
        }
      });
  }
}

export function getDictGroupTypes() {
  return (dispatch) => {
    dispatch(listGroupTypeRequest());
    return listGroupTypeGetRequest()
      .then(response => {
        if (response.status === 200) {
          dispatch(listGroupTypeReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listGroupTypeError(message));
        } else {
          logError(err);
          dispatch(listGroupTypeError(createError("Не удалось загрузить список типов групп")));
        }
      });
  }
}

export function getDictPersonPost() {
  return (dispatch) => {
    dispatch(listPersonPostRequest());
    return listPersonPostGetRequest()
      .then(response => {
        if (response.status === 200) {
          dispatch(listPersonPostReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listPersonPostError(message));
        } else {
          logError(err);
          dispatch(listPersonPostError(createError("Не удалось загрузить список должностей")));
        }
      });
  }
}

export function getDictLegalForms() {
  return (dispatch) => {
    dispatch(listLegalFormRequest());
    return listLegalFormGetRequest()
      .then(response => {
        if (response.status === 200) {
          dispatch(listLegalFormReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listLegalFormError(message));
        } else {
          logError(err);
          dispatch(listLegalFormError(createError("Не удалось загрузить список ОПФ")));
        }
      });
  }
}

export function getDictModules() {
  return (dispatch) => {
    dispatch(listModuleRequest());
    return listModuleGetRequest()
      .then(response => {
        if (response.status === 200) {
          dispatch(listModuleReceive(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(listModuleError(message));
        } else {
          logError(err);
          dispatch(listModuleError(createError("Не удалось загрузить список модулей")));
        }
      });
  }
}

export default {
  getDictRegions,
  getDictMunicipals,
  getDictOrganizations,
  getDictWsCategories,
  getSkillsByCategory,
  getDictEduForms,
  getDictTrialForms,
  getDictTargetGroups,
  getDictLegalForms,
  getDictModules,
  getDictGroupTypes,
  getDictPersonPost
}
